// extracted by mini-css-extract-plugin
export default {"getOffer3":"GetOffer3_getOffer3__TUz+G","header":"GetOffer3_header__1EKqA","people":"GetOffer3_people__fjuXm"};